import { render, staticRenderFns } from "./HeadingImageContact.vue?vue&type=template&id=56f7b930&"
import script from "./HeadingImageContact.vue?vue&type=script&lang=js&"
export * from "./HeadingImageContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports